import analytics from '~/utils/Analytics';
import {
  UPGRADE_MODAL_VIEW,
  UPGRADE_MODAL_SELECT_PLAN,
  STRIPE_MODAL_PAYMENT_PAY,
} from '~/generated/AnalyticsTypes';
import {
  UpgradeModalUids,
  StripePaymentModalUids,
} from '../Components/Modals/UpgradeModals';
import { debounce } from 'lodash';

export enum UpgradeModalViewContext {
  TemplateLimit = 'template_limit',
  CustomTemplateUpsell = 'custom_template_upsell',
  RollupUpsell = 'rollup_upsell',
  IntegrationLimit = 'integration_limit',
  NextgenUpsell = 'nextgen_upsell',
  RemoveBjBadgeUpsell = 'remove_bj_badge_upsell',
  GenericUpgrade = 'generic_upgrade',
  InviteUpsell = 'invite_upsell',
  WorkflowFilterUpsell = 'workflow_filter_upsell',
  BillingPage = 'billing_page',
  NewRollupUpsell = 'new_rollup_upsell',
  GrowthLiteAddon = 'growth_lite_addon',
  CustomDomainAddon = 'custom_domain_addon',
  NewFallbackUpsell = 'new_fallback_upsell',
}

export function upgradeModalUidToContext(uid: string): UpgradeModalViewContext {
  switch (uid) {
    case UpgradeModalUids.GENERIC_UPGRADE_MODAL_SUBNAV:
    case UpgradeModalUids.GENERIC_UPGRADE_MODAL_GREET_CREATION:
      return UpgradeModalViewContext.GenericUpgrade;
    case UpgradeModalUids.REMOVE_BONJORO_BADGE_UPGRADE_MODAL:
      return UpgradeModalViewContext.RemoveBjBadgeUpsell;
    case UpgradeModalUids.NEXT_GEN_TEMPLATE_UPGRADE_MODAL:
    case StripePaymentModalUids.NEXT_GEN_TEMPLATE_UPGRADE_MODAL_PAYMENT:
      return UpgradeModalViewContext.NextgenUpsell;
    case UpgradeModalUids.TEAMS_UPGRADE_MODAL:
      return UpgradeModalViewContext.InviteUpsell;
    case UpgradeModalUids.WORKFLOW_FILTERS_MODAL:
      return UpgradeModalViewContext.WorkflowFilterUpsell;

    case StripePaymentModalUids.REMOVE_POWERED_BY_BONJORO_MODAL_PAYMENT:
    case StripePaymentModalUids.REMOVE_BONJORO_BADGE_UPGRADE_MODAL_PAYMENT:
      return UpgradeModalViewContext.RemoveBjBadgeUpsell;
  }

  return UpgradeModalViewContext.GenericUpgrade;
}

export const trackUpgradeModalView = debounce(
  (context: UpgradeModalViewContext) => {
    analytics.track(UPGRADE_MODAL_VIEW, { context });
  },
  500
);

export function trackUpgradeModalViewForUid(uid: string) {
  trackUpgradeModalView(upgradeModalUidToContext(uid));
}

export function trackUpgradeModalEvent(event: string) {
  return function (plan: string, context: string): void {
    analytics.track(event, { plan, context });
  };
}

export const trackUpgradeModalSelectPlan = trackUpgradeModalEvent(
  UPGRADE_MODAL_SELECT_PLAN
);

interface TrackUploadModalPayArgs {
  plan?: string;
  context: string;
  price: number;
}

export function trackStripeModalPay({
  plan,
  context,
  price,
}: TrackUploadModalPayArgs) {
  return analytics.track(STRIPE_MODAL_PAYMENT_PAY, {
    plan,
    context,
    price,
  });
}
